// src/pages/PrivacyPolicyPage.js
import React from 'react';
import ContentManager from '../components/ContentManager';

const PrivacyPolicyPage = () => {
  return <ContentManager pageType="privacyPolicy" />;
};

export default PrivacyPolicyPage;